import { isEmpty } from 'utils/generics';

export const getHeadingText = (type: string): string => {
    switch (type) {
        case 'make':
            return "Select your car's make";
        case 'model':
            return "Select your car's fuel type";
        case 'variant':
            return "Select your car's \nvariant type";
        default:
            return '';
    }
};

export const getFuelType = ({ allFuelTypes, make }: any) => {
    const uniqueFuelType: string[] = [];

    if (!isEmpty(make.variants)) {
        make.variants.forEach((item) => {
            if (uniqueFuelType.indexOf(item.fuel_type) === -1) {
                // eslint-disable-line
                uniqueFuelType.push(item.fuel_type); // eslint-disable-line
            }
        });
    }

    return uniqueFuelType.map((item) => {
        return {
            name: (allFuelTypes as any)[item],
            key: item,
        };
    });
};

export const getVariantType = ({ allFuelTypes, make, model }: any) => {
    return !isEmpty(make.variants) && !isEmpty(model)
        ? make.variants.filter(
              (item) => (allFuelTypes as any)[item.fuel_type] === model.name
          )
        : [];
};

export const handleNextModal = async ({ type, setMmvType }) => {
    await setMmvType('');
    let nextModal = '';
    if (type === 'make') nextModal = 'model';
    if (type === 'model') nextModal = 'variant';
    await setMmvType(nextModal);
};
